/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Substatus_Return_To_SenderInputs */

const tr_geliver_substatus_return_to_sender = /** @type {(inputs: Geliver_Substatus_Return_To_SenderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gönderene İade`)
};

const en_geliver_substatus_return_to_sender = /** @type {(inputs: Geliver_Substatus_Return_To_SenderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Return to Sender`)
};

const de_geliver_substatus_return_to_sender = /** @type {(inputs: Geliver_Substatus_Return_To_SenderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rücksendung`)
};

const ru_geliver_substatus_return_to_sender = /** @type {(inputs: Geliver_Substatus_Return_To_SenderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Возврат отправителю`)
};

/**
* | output |
* | --- |
* | "Return to Sender" |
*
* @param {Geliver_Substatus_Return_To_SenderInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_substatus_return_to_sender = /** @type {((inputs?: Geliver_Substatus_Return_To_SenderInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Substatus_Return_To_SenderInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_substatus_return_to_sender(inputs)
	if (locale === "de") return de_geliver_substatus_return_to_sender(inputs)
	if (locale === "ru") return ru_geliver_substatus_return_to_sender(inputs)
	return tr_geliver_substatus_return_to_sender(inputs)
});